import authenticate from './authenticate';

export default {
  authenticate,
};
